import { FaPlus } from 'react-icons/fa';
import { useHover } from 'react-use';

export default function DeleteCheckbox({
  onClick,
  className,
  height = 6,
  width = 6,
}) {
  const element = (hovered) => (
    <div
      className={`cursor-pointer flex ${className ? className : ''}`}
      onClick={onClick}
    >
      {!hovered && (
        <input
          className={`pointer-events-none form-checkbox text-primary-dark rounded-md w-${width} h-${height} focus:ring-1 focus-visible:ring-1 focus:ring-primary-dark focus-visible:ring-primary-dark`}
          checked={true}
          type="checkbox"
          readOnly
        />
      )}
      {hovered && (
        <div
          className={`pointer-events-none bg-primary-dark rounded-md w-${width} h-${height} flex justify-center items-center border border-primary-dark ring-0 p-0.5`}
        >
          <FaPlus className="rotate-45 text-white" />
        </div>
      )}
    </div>
  );

  const [hoverable] = useHover(element);

  return hoverable;
}
